module.exports = __webpack_public_path__ + "img/99_get_success.44efa144.gif";